import { render, staticRenderFns } from "./serverPdfDrug.vue?vue&type=template&id=5066a0d0&scoped=true"
import script from "./serverPdfDrug.vue?vue&type=script&lang=js"
export * from "./serverPdfDrug.vue?vue&type=script&lang=js"
import style0 from "./serverPdfDrug.vue?vue&type=style&index=0&id=5066a0d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066a0d0",
  null
  
)

export default component.exports